<template>
    <div>
        <h1>Change Pass</h1>
        <input type="password" class="form-control" placeholder="old password" v-model="objFormPassword.oldPass">
        <input type="password" class="form-control" placeholder="new password" v-model="objFormPassword.newPass">
        <button @click="clickChanePassword()">Change password</button>
    </div>
</template>
<script>
// import Vue from 'vue';
import BzbsProfile from '@/core/Account/service/BzbsProfile.js';
import Account from '@/helper/AccountHelper.js';
// import Modal from '@/components/Modal/Modal.vue';

export default {
    name: "change-pass",
    data: function() {
        return {
            objFormPassword: {
                oldPass: '',
                newPass: '',
            },
        };
    },
    created: function(){
    },
    methods: {
        clickChanePassword: function() {
            console.log(this.objFormPassword);
            var token = Account.getToken();
            BzbsProfile.changePassword(token, this.objFormPassword.oldPass, this.objFormPassword.newPass).subscribe((data) => {
                console.log(data);
            }, (err) => {
                console.log(err);
            });
        },
    }
}
</script>
